var map = {
	"./": 1364,
	"./Clutch": 2680,
	"./Clutch.js": 2680,
	"./NewUi": 2681,
	"./NewUi.js": 2681,
	"./OldUi": 2682,
	"./OldUi.js": 2682,
	"./index": 1364,
	"./index.js": 1364,
	"./style": 862,
	"./style.js": 862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4224;